/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attachment_TypeInputs */



/**
* | output |
* | --- |
* | "Wundo cannot read that kind of file. Share an image, PDF, text, Word or PowerPoint file." |
*
* @param {Chat_Attachment_TypeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_type = /** @type {((inputs?: Chat_Attachment_TypeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_TypeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kan dat soort bestand niet lezen. Deel een afbeelding, pdf, tekst-, Word- of PowerPoint-bestand.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo ne sait pas lire ce type de fichier. Partagez une image, un PDF, un fichier texte, Word ou PowerPoint.")
	return /** @type {LocalizedString} */ ("Wundo cannot read that kind of file. Share an image, PDF, text, Word or PowerPoint file.")
});